// extracted by mini-css-extract-plugin
export default {"messanger":"Messengers_messanger__BjPee","icon":"Messengers_icon__If6fs","link":"Messengers_link__rvnPo"};